

// Types for SUB_PROJECT
export const GET_SUB_PROJECTS_START = "GET_SUB_PROJECTS_START";
export const GET_SUB_PROJECTS_SUCCESS = "GET_SUB_PROJECTS_SUCCESS";
export const GET_SUB_PROJECTS_FAILURE = "GET_SUB_PROJECTS_FAILURE";

// Retrieve single Project
export const GET_SUB_PROJECT_START = "GET_SUB_PROJECT_START";
export const GET_SUB_PROJECT_SUCCESS = "GET_SUB_PROJECT_SUCCESS";
export const GET_SUB_PROJECT_FAILURE = "GET_SUB_PROJECT_FAILURE";
export const CLEAR_SUB_PROJECT = "CLEAR_SUB_PROJECT";


export const CREATE_SUB_PROJECT_START = 'CREATE_SUB_PROJECT_START';
export const CREATE_SUB_PROJECT_SUCCESS = 'CREATE_SUB_PROJECT_SUCCESS';
export const CREATE_SUB_PROJECT_FAILURE = 'CREATE_SUB_PROJECT_FAILURE';

export const GET_SUB_PROJECT_ITEMS_START= 'GET_SUB_PROJECT_ITEMS_START';
export const GET_SUB_PROJECT_ITEMS_SUCCESS = 'GET_SUB_PROJECT_ITEMS_SUCCESS';
export const GET_SUB_PROJECT_ITEMS_FAILURE = 'GET_SUB_PROJECT_ITEMS_FAILURE';

export const GET_SUB_PROJECT_EQUIPMENTS_START= 'GET_SUB_PROJECT_EQUIPMENTS_START';
export const GET_SUB_PROJECT_EQUIPMENTS_SUCCESS = 'GET_SUB_PROJECT_EQUIPMENTS_SUCCESS';
export const GET_SUB_PROJECT_EQUIPMENTS_FAILURE = 'GET_SUB_PROJECT_EQUIPMENTS_FAILURE';

export const CREATE_SUB_PROJECT_ITEM_START = 'CREATE_SUB_PROJECT_ITEM_START';
export const CREATE_SUB_PROJECT_ITEM_SUCCESS = 'CREATE_SUB_PROJECT_ITEM_SUCCESS';
export const CREATE_SUB_PROJECT_ITEM_FAILURE = 'CREATE_SUB_PROJECT_ITEM_FAILURE';

export const UPDATE_SUB_PROJECT_START= "UPDATE_SUB_PROJECT_START";
export const UPDATE_SUB_PROJECT_SUCCESS= "UPDATE_SUB_PROJECT_SUCCESS";
export const UPDATE_SUB_PROJECT_FAILURE= "UPDATE_SUB_PROJECT_FAILURE";


export const DELETE_SUB_PROJECT_START = 'DELETE_SUB_PROJECT_START';
export const DELETE_SUB_PROJECT_SUCCESS = 'DELETE_SUB_PROJECT_SUCCESS';
export const DELETE_SUB_PROJECT_FAILURE = 'DELETE_SUB_PROJECT_FAILURE';

export const OPEN_FORM = 'OPEN_FORM';
export const CLOSE_FORM = 'CLOSE_FORM';
export const SELECTED_SUB_PROJECT = 'SELECTED_SUB_PROJECT';

export const UPLOAD_PHOTO_START= 'UPLOAD_PHOTO_START';
export const UPLOAD_PHOTO_SUCCESS = 'UPLOAD_PHOTO_SUCCESS';
export const UPLOAD_PHOTO_FAILURE = 'UPLOAD_PHOTO_FAILURE';

// Types for Sub project form
export const OPEN_SUB_PROJECT_FORM = 'OPEN_SUB_PROJECT_FORM';
export const OPEN_SUB_PROJECT_SURVEY_FORM = 'OPEN_SUB_PROJECT_SURVEY_FORM';
export const CLOSE_SUB_PROJECT_FORM = 'CLOSE_SUB_PROJECT_FORM';
export const CLOSE_SUB_PROJECT_SURVEY_FORM = 'CLOSE_SUB_PROJECT_SURVEY_FORM';

// Types for survey form actions
export const OPEN_SURVEY_FORM = 'OPEN_SURVEY_FORM';
export const CLOSE_SURVEY_FORM = 'CLOSE_SURVEY_FORM';


// Retrieve single Project element
export const GET_SUB_PROJECT_ELEMENT_START = "GET_SUB_PROJECT_ELEMENT_START";
export const GET_SUB_PROJECT_ELEMENT_SUCCESS = "GET_SUB_PROJECT_ELEMENT_SUCCESS";
export const GET_SUB_PROJECT_ELEMENT_FAILURE = "GET_SUB_PROJECT_ELEMENT_FAILURE";
export const CLEAR_SUB_PROJECT_ELEMENT = "CLEAR_SUB_PROJECT_ELEMENT";